import SimpleMarkdown from 'simple-markdown';

import { concatRegExps } from '../../utils/typograf/utils';

const tableRule = SimpleMarkdown.defaultRules.table;

export const LINK_INSIDE = '(?:\\[[^\\]]*\\]|[^\\]]|\\](?=[^\\[]*\\]))*';
export const LINK_HREF_AND_TITLE = '\\s*<?([^\\s]*?)>?(?:\\s+[\'"]([\\s\\S]*?)[\'"])?\\s*';
// не знаю насколько тут экранирование избыточно
// eslint-disable-next-line no-useless-escape
export const ATTRIBUTES_REGEX = '?:{:((?:\\w*(="[^"]*")?(?=(?:\\s|}))\\s?)*)}';
export const EXTENDED_TABLE_REGEX = concatRegExps(/^ *((?:[\w,: ]+\n)?)/, tableRule.match.regex);

export const ALIGNMENT = {
    '<--': 'left',
    '>-<': 'center',
    '-->': 'right',
    '<->': 'justify',
};

// regex reference https://github.com/Khan/simple-markdown/blob/de4c4f6a5346814ed005be0ad61a1f1fe49ae194/src/index.js#L1041
export const CODE_BLOCK_REGEXP = /^ *(`{3,}|~{3,}) *run_(\S+) *\n([\s\S]+?)\n?\1 *(?:\n *)+\n/;
